import React from "react";
import { Space } from "antd";
import { AxIconWrapper, AxDivider } from "@dynata/axiom3";

class IconWrapper extends React.Component {
  render() {
    return (
      <div className="section button" id="iconwrapper">
        <h3>Icon Wrapper</h3>
        <Space direction="vertical">
          <p>
            Three types of Icon Wrappers are available in several sizes. Any
            Icon from FontAwesome Pro 6 can be used as long as it belongs to
            either light, regular or solid family.
          </p>
        </Space>

        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>

        <Space size="large" direction="vertical">
          <pre>{`<AxIconWrapper type="light" size="12" icon={"fa-star"} />`}</pre>

          <div className="prop-header">
            <p className="props-title">Props</p>
          </div>
          <table className="props-table">
            <tbody>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Value</th>
              </tr>
              <tr>
                <td>type</td>
                <td></td>
                <td>"light | solid | regular"</td>
              </tr>
              <tr>
                <td>size</td>
                <td>Predefined sizes are passed as string.</td>
                <td>
                  "7 | 8 | 10 | 12 | 14 | 16 | 18 | 20 | 24 | 30 | 36 | 48 | 60
                  | 72 | 84"
                </td>
              </tr>
              <tr>
                <td>icon</td>
                <td>
                  Any icon from FontAwesomePro (Light, Regular &amp; Solid) can
                  be used.
                </td>
                <td>
                  <code>{`"fa-star"`}</code>
                </td>
              </tr>
              <tr>
                <td>...others</td>
                <td>All extra props are passed down to a span element that is the outermost parent of the component.</td>
                <td></td>
              </tr>              
            </tbody>
          </table>
        </Space>

        <AxDivider orientation="left" plain>
          Light | Regular | Solid
        </AxDivider>

        <Space size="large" direction="vertical">
          <pre>{`
<AxIconWrapper type="light" size="60" icon={"fa-star"} />
<AxIconWrapper type="regular" size="60" icon={"fa-star"} />
<AxIconWrapper type="solid" size="60" icon={"fa-star"} />
`}</pre>
          <Space>
            <AxIconWrapper type="solid" size="7" icon={"fa-star"} />
            <AxIconWrapper type="solid" size="8" icon={"fa-star"} />
            <AxIconWrapper type="solid" size="10" icon={"fa-star"} />
            <AxIconWrapper type="solid" size="12" icon={"fa-star"} />
            <AxIconWrapper type="solid" size="14" icon={"fa-star"} />
            <AxIconWrapper type="solid" size="16" icon={"fa-star"} />
            <AxIconWrapper type="solid" size="18" icon={"fa-star"} />
            <AxIconWrapper type="solid" size="20" icon={"fa-star"} />
            <AxIconWrapper type="solid" size="24" icon={"fa-star"} />
            <AxIconWrapper type="solid" size="30" icon={"fa-star"} />
            <AxIconWrapper type="solid" size="36" icon={"fa-star"} />
            <AxIconWrapper type="solid" size="48" icon={"fa-star"} />
            <AxIconWrapper type="solid" size="60" icon={"fa-star"} />
            <AxIconWrapper type="solid" size="72" icon={"fa-star"} />
            <AxIconWrapper type="solid" size="84" icon={"fa-star"} />
          </Space>

          <Space>
            <AxIconWrapper type="regular" size="8" icon={"fa-star"} />
            <AxIconWrapper type="regular" size="8" icon={"fa-star"} />
            <AxIconWrapper type="regular" size="12" icon={"fa-star"} />
            <AxIconWrapper type="regular" size="14" icon={"fa-star"} />
            <AxIconWrapper type="regular" size="16" icon={"fa-star"} />
            <AxIconWrapper type="regular" size="18" icon={"fa-star"} />
            <AxIconWrapper type="regular" size="20" icon={"fa-star"} />
            <AxIconWrapper type="regular" size="24" icon={"fa-star"} />
            <AxIconWrapper type="regular" size="30" icon={"fa-star"} />
            <AxIconWrapper type="regular" size="36" icon={"fa-star"} />
            <AxIconWrapper type="regular" size="48" icon={"fa-star"} />
            <AxIconWrapper type="regular" size="60" icon={"fa-star"} />
            <AxIconWrapper type="regular" size="72" icon={"fa-star"} />
            <AxIconWrapper type="regular" size="84" icon={"fa-star"} />
          </Space>

          <Space>
            <AxIconWrapper type="light" size="8" icon={"fa-star"} />
            <AxIconWrapper type="light" size="8" icon={"fa-star"} />
            <AxIconWrapper type="light" size="12" icon={"fa-star"} />
            <AxIconWrapper type="light" size="14" icon={"fa-star"} />
            <AxIconWrapper type="light" size="16" icon={"fa-star"} />
            <AxIconWrapper type="light" size="18" icon={"fa-star"} />
            <AxIconWrapper type="light" size="20" icon={"fa-star"} />
            <AxIconWrapper type="light" size="24" icon={"fa-star"} />
            <AxIconWrapper type="light" size="30" icon={"fa-star"} />
            <AxIconWrapper type="light" size="36" icon={"fa-star"} />
            <AxIconWrapper type="light" size="48" icon={"fa-star"} />
            <AxIconWrapper type="light" size="60" icon={"fa-star"} />
            <AxIconWrapper type="light" size="72" icon={"fa-star"} />
            <AxIconWrapper type="light" size="84" icon={"fa-star"} />
          </Space>
        </Space>
      </div>
    );
  }
}
export default IconWrapper;
